<template>
  <div>
    <div class="head-stat">
      <div class="icon-user">
        <!-- <div class="icon-circle"></div> -->
        <img
          src="../assets/userimage.jpg"
          alt="settings"
          class="circle-image"
        />
      </div>
      <div class="info-beacon">
        <app-stat-value :value="'AE-7DF-TR'" :legend="'beacon-id'"></app-stat-value>
        <app-stat-value :value="'14/10/19 - 18/10/19'" :legend="'Period'"></app-stat-value>
      </div>
      <div class="pie-stat">
        <apexchart type=pie :height="'100%'" :options="chartOptions" :series="series"/>
      </div>
    </div>
    <div class="separator"></div>
    <div>
      <p>{{ $t(question) }}</p>
    </div>

    <div class="button-choice">
      <app-button-rect :text="$t('no')" :buttonColor="'#ED3D62'"></app-button-rect>
      <app-button-rect :text="$t('yes')"></app-button-rect>
    </div>

  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
import StatValueKey from '@/components/StatValueKey.vue';
import ButtonRect from './ButtonRect.vue';

export default {
  name: 'survey-init',
  components: {
    'app-button-rect': ButtonRect,
    'app-stat-value': StatValueKey,
    apexchart: VueApexCharts,
  },
  props: {
    question: {
      type: String,
      default: 'question1',
    },
  },
  data() {
    return {
      msg: 'Hi there!',
      series: [44, 55, 13, 43],
      chartOptions: {
        labels: ['Stock', 'Découpe', 'Hydroformage', 'Ceintrage A'],
        responsive: [{
          breakpoint: 600,
          options: {
            width: 200,
            legend: {
              show: true,
              position: 'bottom',
              horizontalAlign: 'left',
            },
            dataLabels: {
              enabled: false,
            },
          },
        }],
      },
    };
  },

};
</script>

<style scoped>
.head-stat {
  /* min-height: 40vh; */
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  column-gap: 10px;
  row-gap: 10px;
}

.icon-user {
  /* background-color: red; */
  grid-column: 1 / 2;
  grid-row: 1 / 2;
  display: flex;
  align-items: flex-start;
}

.info-beacon {
  /* background-color: violet; */
  grid-column: 1 / 2;
  grid-row: 2;
}

.pie-stat {
  /* background-color: yellow; */
  grid-column: 2;
  grid-row: 1 / 3;
  padding-top: 10px;
  max-width: 100%;
}

.icon-circle {
  border-radius: 50%;
  background-color: #32A6ED;
}

.button-choice {
  display: flex;
  justify-content: space-between;
}

.separator {
  border-bottom: 1px solid grey;
  width: 100%;
}

.circle-image {
  min-height: 20vh;
  margin-top: 2vh;
}
</style>
